// extracted by mini-css-extract-plugin
module.exports = {"counter":"style_counter__2LOPj","count":"style_count__100sF"};